export default (state, componentIds, accountId) => {
	const newState = state.map((account) => {
		if (accountId === account.id) {
			return {...account, relatedComponents: [...new Set([...componentIds, ...account.relatedComponents])]};
		}
		return account;
	});

	return newState;
};
